import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {
  useTaskStore
} from '@components/my-tasks/tasks-list/task-store'
import {StickerItem} from '@components/sticker'

const TwContainer = tw.div`
  flex
  flex-wrap
  gap-4
  py-4
`

export const TaskStickersColumn = observer(() => {
  const [state, store] = useTaskStore()

  if (!state) {
    return null;
  }

  return (
    <TwContainer>
      {store.taskStickers.map(sticker => {
        return (
          <StickerItem
            disabled
            draggable={false}
            withMenu={false}
            key={sticker.id}
            location="task"
            taskId={state.taskId}
            sticker={sticker}
          />
        )
      })}
    </TwContainer>
  )
})
